import { GraphQLClient } from 'graphql-request';
import { getRuntimeConfig } from '../runtime-config';
import { useMsal } from '@azure/msal-react';
import { loginRequest, apiRequest, msalConfig } from '../authentication/authConfig';
import { useEffect } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalInstance } from '../authentication/useAccessToken';
import { getAccessToken } from '../authentication/useAccessToken';

const config = getRuntimeConfig();

let url = config.GRAPHQL_ENDPOINT


if (url === 'undefined' || !url) {
  //fallback if config fails
  //to be removed in production
  url = import.meta.env.VITE_GRAPHQL_ENDPOINTLOCAL;
}


class GraphQLClientServiceTest {
  constructor(endpoint = url) {
    this._defaultEndPoint = endpoint;
    this._graphQLClient = new GraphQLClient(this._defaultEndPoint, {
      headers: {
        //"api-key": api_key,
        'Content-Type': 'application/json',
        "Accept":"application/json"
      },
    });
  }

  async executeQueryAsync(query) {

    const controller = new AbortController();
    const timeOutID = setTimeout(()=> controller.abort(), 30000)
    try {
       
      const accessToken = await getAccessToken();
      // console.log("graphql endpoint ", url);
      // const request = await fetch(url, {
      // method: "POST",
      // headers: {
      //     "Content-Type": "application/json",
      //     "Accept":"application/json"
      //   },
      // body: JSON.stringify({ query }),
      // });
      
     //change to env variable
    //  console.log("Testing to be removed in prod",url)
      const request = await fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      body: JSON.stringify({ query }),
      signal: controller.signal,

      });
    
    
    const response = await request.json();
   // console.log("Response from loacl api:" , response);
  
    
    if (response.errors) {
      throw new Error(`GraphQL Errors: ${JSON.stringify(response.errors)}`);
    }
    
    return response;
  } 
  // catch (ex) {
  //     console.warn(`Error type: ${ex.name}`);
  //     console.warn(`Error message: ${ex.message}`);
  //     console.warn(`Full error:`, ex);
  //     return null;
  //   }
  catch (error) {
    if (error.name === 'AbortError') {
      //throw new Error(`Request timed out after ${timeOutID / 1000} seconds`);
         console.error(`Request timed out after ${timeOutID / 1000} seconds`);
      return "TimedOUT";
    }

    throw error;

  } finally {
    clearTimeout(timeOutID);
    }
  }   
 
}

export default GraphQLClientServiceTest;

